import React, { FC } from "react";
import tick from "assets/icons/check.svg";

interface CheckboxProps {
  label: string;
  labelClassName?: string;
  checkboxClassName?: string;
  checked?: boolean;
  onChange?: any;
}
const Checkbox: FC<CheckboxProps> = ({ label, labelClassName, checked, onChange, checkboxClassName }) => {
  return (
    <div className="flex items-center">
      <label className="relative inline-flex  gap-2 items-center cursor-pointer">
        <input type="checkbox" checked={checked} className="sr-only peer" onChange={onChange} />
        <div className={`w-5 h-5 rounded  ${checked && "bg-black"} flex items-center  justify-center transition-all duration-300 ${checked ? "shadow-md" : "bg-white border-[1px] border-gray-400"} ${checkboxClassName}`}>{checked && <img src={tick} alt="tick" />}</div>
        <p className={` text-sm font-medium ${labelClassName}`}>{label}</p>
      </label>
    </div>
  );
};

export default Checkbox;
